var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-exec-summary" }, [
    _c("div", { staticClass: "viq-exec-summary__badge" }, [
      _c(
        "svg",
        {
          attrs: {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M3 8l4 4 6-6",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
        ]
      ),
      _vm._v("\n    Report Complete\n  "),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "viq-exec-summary__card" }, [
      _c("h3", { staticClass: "viq-exec-summary__title" }, [
        _vm._v("Executive Summary"),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "viq-exec-summary__content",
        domProps: { innerHTML: _vm._s(_vm.renderedSummary) },
      }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "viq-exec-summary__sections-preview" },
      [
        _c("h4", { staticClass: "viq-exec-summary__sections-title" }, [
          _vm._v("Report Sections"),
        ]),
        _vm._v(" "),
        _vm._l(_vm.sections, function (section, i) {
          return _c(
            "div",
            { key: i, staticClass: "viq-exec-summary__section-item" },
            [
              _c("span", { staticClass: "viq-exec-summary__section-num" }, [
                _vm._v(_vm._s(i + 1)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "viq-exec-summary__section-name" }, [
                _vm._v(_vm._s(section.title)),
              ]),
            ]
          )
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "viq-exec-summary__actions" },
      [
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.exportPdf } },
          [
            _c(
              "svg",
              {
                staticStyle: {
                  "margin-right": "6px",
                  "vertical-align": "middle",
                },
                attrs: {
                  width: "14",
                  height: "14",
                  viewBox: "0 0 14 14",
                  fill: "none",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M12 9v3H2V9M7 1v8M4 5l3 3 3-3",
                    stroke: "currentColor",
                    "stroke-width": "1.2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
              ]
            ),
            _vm._v("\n      Export as PDF\n    "),
          ]
        ),
        _vm._v(" "),
        _vm.$config.features && _vm.$config.features.viqShare
          ? _c("el-button", { on: { click: _vm.share } }, [
              _vm._v("\n      Save & Share\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("el-button", { on: { click: _vm.newReport } }, [
          _vm._v("\n      New Report\n    "),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }